import Vue from "vue";
import { api } from "../API";
import StandaloneBudgetSlider from "../vue/StandaloneBudgetSlider.vue";

export default {
    init() {
        this._lazyRequestSent = false;
        this._lazyLoad();
    },
    _lazyLoad() {
        window.addEventListener("scroll", this._onScroll);
    },
    _onScroll() {
        if (this._lazyRequestSent) {
            return;
        }

        if (window.pageYOffset > 20) {
            this._lazyRequestSent = true;

            window.removeEventListener("scroll", this._onScroll);

            setTimeout(() => {
                new Vue({
                    data: window.vueState,
                    el: "#lobby-budget-slider",
                    template: `<StandaloneBudgetSlider />`,
                    components: { StandaloneBudgetSlider }
                });
            });
        }
    },
    finalize() {

    }
};
